export enum ConsentTypeEnum {
  AGREE = 'AGREE',
  DISAGREE = 'DISAGREE',
  UNKNOWN = 'UNKNOWN',
}
